import React from 'react';

const RequiredIndicator = ({ label }) => <b>{label}<sup style={{ color: 'crimson' }}>{label ? '*' : ' '}&nbsp;</sup></b>
export default RequiredIndicator;
